import { ReactElement, useState } from 'react';
import { Component as CaretDownIcon } from 'icons/icon-ui--caret-outline.svg';
import { Component as CaretUpIcon } from 'icons/icon-ui--caret-up-outline.svg';
import styles from './ProductDisplayPage.module.scss';

type Instruction = {
  stepNumber: number;
  title: string;
  description: string;
  media?: string | null;
  mediaAlt?: string | null;
};

type Props = {
  instructions: Instruction[];
  initiallyExpanded?: boolean;
};

export function Instructions({
  instructions,
  initiallyExpanded = false,
}: Props): ReactElement {
  const [showInstructions, setShowInstructions] = useState(initiallyExpanded);
  const toggleShowInstructions = () => setShowInstructions((prev) => !prev);

  return (
    <div className={styles.accordion_container}>
      <div
        role="button"
        tabIndex={0}
        onClick={toggleShowInstructions}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleShowInstructions();
          }
        }}
      >
        <div className={styles.dropdown}>
          <h3 className={styles.accordion_title}>Instructions</h3>
          {showInstructions ? <CaretUpIcon width={23} /> : <CaretDownIcon width={23} />}
        </div>
      </div>
      <hr className={styles.accordion_divider} />
      {showInstructions && (
        <div className={styles.scroll_container}>
          <div className={styles.instructions_container}>
            {instructions.map((instruction) => (
              <div
                className={`${styles.instruction} ${instruction.media ? styles.instruction_with_image : ''}`}
                key={instruction.stepNumber}
              >
                <div className={styles.instruction_content}>
                  <div style={{ flex: 1 }}>
                    <div className={styles.instruction_header}>
                      <div className={styles.step_number}>
                        {instruction.stepNumber}
                      </div>
                      <div className={styles.step_title}>
                        {instruction.title}
                      </div>
                    </div>
                    <p>{instruction.description}</p>
                  </div>
                  {instruction.media && (
                    <div className={styles.instruction_image}>
                      <img
                        src={instruction.media}
                        alt={instruction.mediaAlt ?? ''}
                        loading="lazy"
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
